module.exports = __webpack_public_path__ + "static/media/ios-arrow-round-down.3ceed256.svg";